
const cyNavList = [
  {
    id: 10,
    name: "系统首页",
    img: require('@/assets/img/menu/xtsy.png'),
    path: '/home',
    // authId: 'home',
    // data: [
    //   {
    //     id: 1001,
    //     name: '首页概览',
    //     path: '/index',
    //     navTitle: "系统首页 / 首页概览"
    //   }
    // ]
  },
  {
    id: 20,
    name: "机构管理",
    img: require('@/assets/img/menu/jggl.png'),
    path: '/xjjg',
    authId: 'xjjg',
    data: [
      {
        id: 2001,
        name: '下级机构',
        path: '/xjjg',
        navTitle: "机构管理 / 下级机构",
        authId: 'jggl_xjjg',

      },
      {
        id: 2002,
        name: '机构员工',
        path: '/jgyg',
        navTitle: "机构管理 / 机构员工",
        authId: 'jggl_jgyg',

      },
      {
        id: 2003,
        name: '员工权限',
        path: '/ygqx',
        navTitle: "机构管理 / 员工权限",
        authId: 'jggl_ygqx',
      },
      // {
      //   id: 2003,
      //   name: '机构分润',
      //   path: '/jgfr',
      //   navTitle: "机构管理 / 机构分润",
      //   authId: 'jgfr',
      // },

    ]
  },
  {
    id: 30,
    name: "商户管理",
    img: require('@/assets/img/menu/shgl.png'),
    path: '/shxx',
    authId: 'shxx',
    data: [
      {
        id: 3001,
        name: '商户信息',
        path: '/shxx',
        navTitle: "商户管理 / 商户信息",
        authId: 'shgl_shxx',

      },
      {
        id: 3002,
        name: '门店信息',
        path: '/mdxx',
        navTitle: "商户管理 / 门店信息",
        authId: 'shgl_mdxx',
      }
    ]
  },
  {
    id: 40,
    name: "产品码库",
    img: require('@/assets/img/menu/cpmk.png'),
    path: '/jhmk',
    authId: 'gk',
    data: [
      {
        id: 4001,
        name: '激活码库',
        path: '/jhmk',
        navTitle: "产品码库 / 激活码库",
        authId: 'cpmk_jhmk',
      },
      {
        id: 4006,
        name: '下级码库',
        path: '/xjmk',
        navTitle: "产品码库 / 下级码库",
        authId: 'cpmk_jhmk',
      },
      {
        id: 4002,
        name: '划拨明细',
        path: '/hbmx',
        navTitle: "产品码库 / 划拨明细"
        ,
        authId: 'cpmk_hbmx',
      },
      {
        id: 4003,
        name: '划拨统计',
        path: '/hbhz',
        navTitle: "产品码库 / 划拨统计",
        authId: 'cpmk_hbtj',
      }, {
        id: 4004,
        name: '外卖团购',
        path: '/wmtg',
        navTitle: "产品码库 / 外卖团购",
        authId: 'cpmk_wmtg',
      },
      {
        id: 4005,
        name: '三方码库',
        path: '/sfmk',
        navTitle: "产品码库 / 三方码库",
        authId: 'cpmk_sfmk',
      },
    ]
  }, {
    id: 50,
    name: "在线商店",
    img: require('@/assets/img/menu/zxsd.png'),
    path: '/sddd',
    authId: 'gk',
    data: [
      {
        id: 5001,
        name: '商店订单',
        path: '/sddd',
        navTitle: "在线商店 / 商店订单",
        authId: 'zxsd_sddd',
      },

    ]
  }, {
    id: 60,
    name: "系统仓库",
    img: require('@/assets/img/menu/xtck.png'),
    path: '/spck',
    authId: 'gk',
    data: [
      {
        id: 6001,
        name: '商品仓库',
        path: '/prolist',
        navTitle: "系统仓库 / 商品仓库",
        authId: 'xtck_spck',
      }, {
        id: 6002,
        name: '图片仓库',
        path: '/imglist',
        navTitle: "系统仓库 / 图片仓库",
        authId: 'xtck_tpck',
      }, {
        id: 6004,
        name: '文件仓库',
        path: '/wjck',
        navTitle: "系统仓库 / 文件仓库",
        authId: 'xtck_wjck',
      },
      // {
      //   id: 6003,
      //   name: '视频仓库',
      //   path: '/vspck',
      //   navTitle: "系统仓库 / 视频仓库"
      // },

    ]
  }
]

export default {
  cyNavList,
}



// WEBPACK FOOTER //
// ./src/assets/listData/listData.js